import { render, staticRenderFns } from "./AddNewDnsZoneModal.vue?vue&type=template&id=498b7b35&"
import script from "./AddNewDnsZoneModal.vue?vue&type=script&lang=js&"
export * from "./AddNewDnsZoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports